import { getLeadSourceIcon } from '../helpers/leadSourceIcon'
import { LovableIcon } from '../../../components/icons/LovableIcon'

interface Props {
  name?: string | null
  className?: string
}

/** Deriva un acrónimo corto (máx. 3 letras) para lead sources sin ícono de marca
 *  conocido — ej. "Referido Interno" → "RI", "Zapier" → "ZAP". */
function acronymFor(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean)
  if (words.length >= 2) {
    return words.slice(0, 3).map((w) => w[0].toUpperCase()).join('')
  }
  return name.slice(0, 3).toUpperCase()
}

/** Identificador visual compacto del origen del lead, para no tener que abrir el
 *  detalle solo para saber de dónde vino (Cards / Table). */
export const LeadSourceBadge: React.FC<Props> = ({ name, className }) => {
  if (!name) return null

  if (name.trim().toLowerCase() === 'lovable') {
    return (
      <span className={`badge badge-light d-inline-flex align-items-center gap-1 ${className ?? ''}`} title={name}>
        <LovableIcon size={12} />
      </span>
    )
  }

  const icon = getLeadSourceIcon(name)

  return (
    <span className={`badge badge-light ${className ?? ''}`} title={name}>
      {icon ? <i className={`bi ${icon}`} /> : acronymFor(name)}
    </span>
  )
}
